import { render } from "./MediaPlaceholder.vue?vue&type=template&id=469d836e"
import script from "./MediaPlaceholder.vue?vue&type=script&lang=js"
export * from "./MediaPlaceholder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__